import { Routes } from '@angular/router';
import { GuideComponent } from './guide.component';

export const guideRoutes: Routes = [
  {
    path: '',
    component: GuideComponent,

    children: [
      {
        path: 'welcome',
        loadComponent: () => import('./welcome-teams/welcome-teams.component').then((m) => m.WelcomeTeamsComponent),
      },
      {
        path: 'results',
        loadComponent: () => import('./results-teams/results-teams.component').then((m) => m.ResultsTeamsComponent),
      },
      {
        path: 'your',
        loadComponent: () => import('./your-teams/your-teams.component').then((m) => m.YourTeamsComponent),
      },
      {
        path: 'insights',
        loadComponent: () => import('./insights-teams/insights-teams.component').then((m) => m.InsightsTeamsComponent),
      },
      {
        path: 'courses',
        loadComponent: () => import('./courses-teams/courses-teams.component').then((m) => m.CoursesTeamsComponent),
      },
      {
        path: 'exploring',
        loadComponent: () => import('./exploring-teams/exploring-teams.component').then((m) => m.ExploringTeamsComponent),
      },
      {
        path: '',
        redirectTo: 'welcome',
        pathMatch: 'full',
      },
    ],
  },
];
